import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Content, Root, Trigger } from '@radix-ui/react-collapsible';
import { type Address } from 'viem';
import { faChevronDown, faGift } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { interfaceIds } from '@soundxyz/sdk/constants';
import type { GiftSource } from '@soundxyz/utils/analytics';
import { ParamsStore } from '@context/params';
import { trackClickEvent } from '@lib/analytics';
import { GiftingAddressInput } from './GiftingAddressInput';

export const ALLOWED_INTERFACES_FOR_GIFTING = {
  IRangeEditionMinterV2: interfaceIds.IRangeEditionMinterV2,
  IRangeEditionMinterV2_1: interfaceIds.IRangeEditionMinterV2_1,
} as const;

export const GiftingDropdown = ({
  releaseId,
  sourceComponent,
  inputDisabled = false,
  setGiftAddress,
  open,
  setOpen,
  eligibleQuantity,
}: {
  releaseId: string;
  sourceComponent: GiftSource;
  inputDisabled?: boolean;
  setGiftAddress: React.Dispatch<React.SetStateAction<Address | null>>;
  open: boolean;
  setOpen: (open: boolean) => void;
  eligibleQuantity: number;
}) => {
  const [inputTouched, setInputTouched] = React.useState(false);
  const [inputValue, setInputValue] = React.useState<string | null>(null);

  return (
    <Root
      open={open}
      onOpenChange={() => {
        if (!!open) {
          ParamsStore.gift_to = null;
          setInputValue(null);
          setInputTouched(false);
          setGiftAddress(null);
        }
      }}
    >
      <Trigger
        type="button"
        className="flex w-full items-center justify-between font-base text-base-m text-base800"
        onClick={() => {
          //not open means user did not click from the gift button but on the checkout modal instead
          if (!open) {
            trackClickEvent({
              event: 'Gift Clicked',
              properties: {
                associationId: releaseId,
                associationType: 'Release',
                sourceComponent,
              },
            });
          }
          setOpen(!open);
        }}
      >
        <div className="flex items-center gap-1">
          <FontAwesomeIcon icon={faGift} />
          Gift this song
        </div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className="p-1 text-base500 group-hover:text-base900 data-[state=closed]:rotate-0 data-[state=open]:rotate-180"
          data-state={!!open ? 'open' : 'closed'}
        />
      </Trigger>
      <Content className="h-fit pt-3">
        <GiftingAddressInput
          eligibleQuantity={eligibleQuantity}
          setGiftAddress={setGiftAddress}
          setOpen={setOpen}
          inputDisabled={inputDisabled}
          inputTouched={inputTouched}
          setInputTouched={setInputTouched}
          inputValue={inputValue}
          setInputValue={setInputValue}
        />
      </Content>
    </Root>
  );
};
